(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-silhouette-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-silhouette-editor')) {
    class CCSilhouettePackage {
  static blob(c,type='image/png'){return new Promise((resolve,reject)=>c.toBlob(b=>b?resolve(b):reject(Error('encode')),type,.92));}
  static bytes(s){return new TextEncoder().encode(s);}
  static crc(data){let crc=0xffffffff;for(const byte of data){crc^=byte;for(let k=0;k<8;k++)crc=(crc>>>1)^((crc&1)?0xedb88320:0);}return(crc^0xffffffff)>>>0;}
  static async density(blob,width,height,widthMm,heightMm){
    if(!widthMm)return blob;
    const input=new Uint8Array(await blob.arrayBuffer()),view=new DataView(input.buffer),parts=[input.slice(0,8)];
    const chunk=new Uint8Array(21),v=new DataView(chunk.buffer);v.setUint32(0,9);chunk.set(this.bytes('pHYs'),4);v.setUint32(8,Math.round(width/widthMm*1000));v.setUint32(12,Math.round(height/heightMm*1000));chunk[16]=1;v.setUint32(17,this.crc(chunk.slice(4,17)));
    for(let p=8;p<input.length;){const size=view.getUint32(p)+12,type=String.fromCharCode(...input.slice(p+4,p+8));if(type!=='pHYs')parts.push(input.slice(p,p+size));if(type==='IHDR')parts.push(chunk);p+=size;}
    return new Blob(parts,{type:'image/png'});
  }
  static async zip(entries){
    const chunks=[],central=[];let offset=0;
    for(const [path,blob] of entries){
      const name=this.bytes(path),data=new Uint8Array(await blob.arrayBuffer());let crc=0xffffffff;
      for(const byte of data){crc^=byte;for(let k=0;k<8;k++)crc=(crc>>>1)^((crc&1)?0xedb88320:0);}crc=(crc^0xffffffff)>>>0;
      const header=new Uint8Array(30+name.length),v=new DataView(header.buffer);
      v.setUint32(0,0x04034b50,true);v.setUint16(4,20,true);v.setUint16(6,0x800,true);v.setUint16(12,33,true);v.setUint32(14,crc,true);v.setUint32(18,data.length,true);v.setUint32(22,data.length,true);v.setUint16(26,name.length,true);header.set(name,30);
      const directory=new Uint8Array(46+name.length),d=new DataView(directory.buffer);
      d.setUint32(0,0x02014b50,true);d.setUint16(4,20,true);d.setUint16(6,20,true);d.setUint16(8,0x800,true);d.setUint16(14,33,true);d.setUint32(16,crc,true);d.setUint32(20,data.length,true);d.setUint32(24,data.length,true);d.setUint16(28,name.length,true);d.setUint32(42,offset,true);directory.set(name,46);
      chunks.push(header,data);central.push(directory);offset+=header.length+data.length;
    }
    const end=new Uint8Array(22),v=new DataView(end.buffer);v.setUint32(0,0x06054b50,true);v.setUint16(8,entries.length,true);v.setUint16(10,entries.length,true);v.setUint32(12,central.reduce((n,c)=>n+c.length,0),true);v.setUint32(16,offset,true);
    return new Blob([...chunks,...central,end],{type:'application/zip'});
  }

    }
    class CCSilhouetteEditor extends HTMLElement {
      static segmenterPromise;

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.words = JSON.parse(this.querySelector('[data-silhouette-words]').textContent);
        this.file = this.querySelector('[data-photo]');
        this.shape = this.querySelector('[data-shape]');
        this.status = this.querySelector('[data-status]');
        this.controls = this.querySelector('[data-controls]');
        this.edge = this.querySelector('[data-edge]');
        this.size = this.querySelector('[data-size]');
        this.nameInput = this.querySelector('[data-text]');
        this.namePreview = this.querySelector('[data-name]');
        this.token = 0;
        this.form = this.querySelector('form');
        this.x = this.querySelector('[data-x]');this.y = this.querySelector('[data-y]');
        this.font = this.querySelector('[data-font]');this.nameSize = this.querySelector('[data-name-size]');
        this.photos = [];this.designWorking = false;
        this.beforeUnload = e => {if(!this.navigatingToCart&&(this.nameInput.value||this.mask)){e.preventDefault();e.returnValue=true;}};
        window.addEventListener('beforeunload',this.beforeUnload);
        this.x.addEventListener('input',()=>this.updateSize());this.y.addEventListener('input',()=>this.updateSize());
        this.font.addEventListener('change',()=>this.updateName());this.nameSize.addEventListener('input',()=>this.updateName());
        this.form.addEventListener('submit',e=>this.submit(e));
        this.form.elements.quantity.addEventListener('input',()=>this.updatePrice());
        this.querySelectorAll('[data-addon]').forEach(addon=>addon.addEventListener('change',()=>this.updatePrice()));
        this.querySelectorAll('[data-tier]').forEach(button=>button.addEventListener('click',()=>{this.form.elements.quantity.value=button.dataset.tier;this.updatePrice();}));
        this.updatePrice();
        this.querySelector('[data-save-design]').addEventListener('click',()=>this.saveDesign());
        this.querySelector('[data-load-design]').addEventListener('click',()=>this.querySelector('[data-design-file]').click());
        this.querySelector('[data-design-file]').addEventListener('change',()=>this.loadDesign());
        this.querySelector('[data-account-save]').addEventListener('click',()=>this.saveAccount());
        this.querySelector('[data-account-copy]').addEventListener('click',()=>this.saveAccount(true));
        const stage=this.q('.cc-stage'),sticky=this.q('.cc-preview-sticky'),previewImage=this.q('.cc-product-image'),purchase=this.q('[data-purchase]'),previewSpacer=this.q('.cc-preview-shrink-spacer');
        this.previewViewportWidth=Math.round(window.innerWidth);
        this.previewHeightBasis=Math.max(500,window.innerHeight);
        this.previewScroller=document.querySelector('.page-wrapper');
        this.previewZone=this.q('.cc-preview-scroll-zone');
        this.previewMaxWidth=520;
        // Vaste eindhoogte voor alle desktop-previews, gelijk aan de bamboeplank.
        this.previewFixedHeight=265;
        // Start direct met verkleinen zodra de preview sticky wordt.
        // 1 px scroll = 1 px verandering in previewhoogte.
        this.previewDeadDistance=0;
        this.previewScrollFrame=0;
        this.previewBaseMetrics=null;
        this.previewStickyTop=null;
        this.previewReleaseGap=24;
        this.previewReleaseStart=null;
        this.previewMobileReleaseGap=0;
        this.previewMobileStickyTop=null;
        this.previewMobileReleaseStart=null;
        this.previewUsesPageScroller=()=>{
          const scroller=this.previewScroller;
          return Boolean(scroller&&scroller.scrollHeight>scroller.clientHeight+1&&/(auto|scroll)/.test(getComputedStyle(scroller).overflowY));
        };
        this.getPreviewScrollTop=()=>this.previewUsesPageScroller()?this.previewScroller.scrollTop:window.scrollY;
        this.measureDesktopPreview=()=>{
          if(!stage||!sticky||!this.previewZone||window.matchMedia('(max-width:749px)').matches)return;
          this.style.removeProperty('--cc-desktop-preview-width');
          sticky.style.removeProperty('top');
          const baseWidth=stage.offsetWidth;
          const baseHeight=stage.offsetHeight;
          const stickyHeight=sticky.offsetHeight;
          if(!baseWidth||!baseHeight||!stickyHeight)return;
          this.previewStickyTop=parseFloat(getComputedStyle(sticky).top)||0;
          this.previewBaseMetrics={baseWidth,baseHeight,stickyHeight};
        };
        this.updateDesktopPreview=()=>{
          if(!stage||!sticky||!this.previewZone)return;
          if(window.matchMedia('(max-width:749px)').matches){
            sticky.classList.remove('cc-preview-is-small');
            this.style.removeProperty('--cc-desktop-preview-width');
            this.style.setProperty('--cc-preview-compensation','0px');
            this.previewReleaseStart=null;

            const scrollTop=this.getPreviewScrollTop();
            if(this.previewMobileStickyTop===null){
              sticky.style.removeProperty('top');
              this.previewMobileStickyTop=parseFloat(getComputedStyle(sticky).top)||0;
            }
            const baseTop=this.previewMobileStickyTop;

            if(purchase){
              const releaseAt=baseTop+sticky.offsetHeight+this.previewMobileReleaseGap;
              const purchaseTop=purchase.getBoundingClientRect().top;

              if(this.previewMobileReleaseStart===null && purchaseTop<=releaseAt){
                this.previewMobileReleaseStart=scrollTop;
              }

              if(this.previewMobileReleaseStart!==null){
                if(scrollTop<this.previewMobileReleaseStart){
                  this.previewMobileReleaseStart=null;
                  sticky.style.top=baseTop.toFixed(2)+'px';
                  sticky.style.clipPath='none';
                }else{
                  const releaseDelta=scrollTop-this.previewMobileReleaseStart;
                  sticky.style.top=(baseTop-releaseDelta).toFixed(2)+'px';
                  // Laat de preview onder de Carved Crafts-header verdwijnen in plaats
                  // van er overheen te schuiven. De zichtbare bovenzijde blijft exact
                  // op de onderkant van de header liggen.
                  const clipTop=Math.min(sticky.offsetHeight,releaseDelta);
                  sticky.style.clipPath='inset('+clipTop.toFixed(2)+'px 0 0 0)';
                }
              }else{
                sticky.style.top=baseTop.toFixed(2)+'px';
                sticky.style.clipPath='none';
              }
            }else{
              sticky.style.top=baseTop.toFixed(2)+'px';
              sticky.style.clipPath='none';
            }
            return;
          }
          sticky.style.clipPath='none';
          if(!this.previewBaseMetrics)this.measureDesktopPreview();
          const metrics=this.previewBaseMetrics;
          if(!metrics)return;
          const scrollTop=this.getPreviewScrollTop();
          const stickyTop=this.previewStickyTop??(parseFloat(getComputedStyle(sticky).top)||0);
          const zoneTop=this.previewZone.getBoundingClientRect().top;
          const stickyStart=scrollTop+zoneTop-stickyTop;
          const shrinkStart=stickyStart+this.previewDeadDistance;
          const scrolled=Math.max(0,scrollTop-shrinkStart);
          const targetHeight=this.previewFixedHeight;
          const heightDelta=targetHeight-metrics.baseHeight;
          const direction=Math.sign(heightDelta);
          const resizeDistance=Math.abs(heightDelta);
          const resizePx=Math.min(resizeDistance,scrolled);
          const currentHeight=metrics.baseHeight+(direction*resizePx);
          const progress=resizeDistance>0?resizePx/resizeDistance:1;

          sticky.classList.toggle('cc-preview-is-small',progress>=.999);

          if(scrolled<=0){
            this.style.removeProperty('--cc-desktop-preview-width');
            this.style.setProperty('--cc-preview-compensation','0px');
            this.previewReleaseStart=null;
            if(this.previewStickyTop!==null)sticky.style.top=this.previewStickyTop.toFixed(2)+'px';
            return;
          }

          // De preview verandert exact evenveel pixels als er wordt gescrold.
          // Daardoor beweegt de onderkant van de preview synchroon met de velden eronder.
          const width=metrics.baseWidth*(currentHeight/metrics.baseHeight);
          this.style.setProperty('--cc-desktop-preview-width',width.toFixed(2)+'px');

          // Vul alleen de hoogte op die de preview werkelijk kleiner is geworden.
          // Dit voorkomt dat Tekst 1 achter de sticky preview schuift, zonder een vaste lege strook.
          let compensation=Math.max(0,metrics.baseHeight-stage.offsetHeight);
          this.style.setProperty('--cc-preview-compensation',compensation.toFixed(2)+'px');

          // Zodra 'Aantal, prijs en extra's' de preview bereikt, onthouden we
          // exact de scrollpositie. Vanaf dat punt beweegt de preview 1-op-1 mee:
          // 1 px verder scrollen = 1 px omhoog. De spacer blijft gelijk, zodat de
          // rest van de editor zelf ook gewoon met normale scrollsnelheid blijft bewegen.
          if(purchase){
            const baseTop=this.previewStickyTop??stickyTop;
            const releaseAt=baseTop+sticky.offsetHeight+this.previewReleaseGap;
            const purchaseTop=purchase.getBoundingClientRect().top;

            if(this.previewReleaseStart===null && purchaseTop<=releaseAt){
              this.previewReleaseStart=scrollTop-Math.max(0,releaseAt-purchaseTop);
            }

            if(this.previewReleaseStart!==null){
              if(scrollTop<this.previewReleaseStart){
                this.previewReleaseStart=null;
                sticky.style.top=baseTop.toFixed(2)+'px';
                sticky.style.clipPath='none';
              }else{
                const releaseDelta=scrollTop-this.previewReleaseStart;
                sticky.style.top=(baseTop-releaseDelta).toFixed(2)+'px';
                // Desktop: laat de preview onder de Carved Crafts-header verdwijnen,
                // zodat hij nooit over de headerlijn heen zichtbaar wordt.
                const clipTop=Math.min(sticky.offsetHeight,releaseDelta);
                sticky.style.clipPath='inset('+clipTop.toFixed(2)+'px 0 0 0)';
              }
            }else{
              sticky.style.top=baseTop.toFixed(2)+'px';
              sticky.style.clipPath='none';
            }
          }
        };
        this.fitPreview=()=>{
          if(!window.matchMedia('(max-width:749px)').matches){
            this.style.removeProperty('--cc-preview-width');
            this.updateDesktopPreview();
            return;
          }
          this.style.removeProperty('--cc-desktop-preview-width');
          if(!stage?.offsetWidth||!sticky?.scrollHeight)return;
          const maxHeight=Math.max(300,Math.min(390,this.previewHeightBasis*.43));
          const availableWidth=Math.max(200,Math.min(330,(sticky.clientWidth||this.clientWidth)-16));
          const scaledWidth=Math.floor(stage.offsetWidth*maxHeight/sticky.scrollHeight);
          const width=Math.max(200,Math.min(availableWidth,scaledWidth));
          this.style.setProperty('--cc-preview-width',width+'px');
        };
        this.onPreviewScroll=()=>{
          if(this.previewScrollFrame)return;
          this.previewScrollFrame=requestAnimationFrame(()=>{
            this.previewScrollFrame=0;
            this.updateDesktopPreview();
          });
        };
        this.onPreviewResize=()=>{
          const currentWidth=Math.round(window.innerWidth);
          if(Math.abs(currentWidth-this.previewViewportWidth)>30){
            this.previewViewportWidth=currentWidth;
            this.previewHeightBasis=Math.max(500,window.innerHeight);
            this.style.removeProperty('--cc-preview-width');
            this.style.removeProperty('--cc-desktop-preview-width');
            this.style.setProperty('--cc-preview-compensation','0px');
            sticky.style.removeProperty('top');
            sticky.style.removeProperty('clip-path');
            this.previewReleaseStart=null;
            this.previewMobileReleaseStart=null;
            this.previewMobileStickyTop=null;
            this.previewBaseMetrics=null;
            this.previewStickyTop=null;
            requestAnimationFrame(()=>requestAnimationFrame(()=>{
              this.measureDesktopPreview();
              this.fitPreview();
            }));
          }else if(!window.matchMedia('(max-width:749px)').matches){
            this.updateDesktopPreview();
          }
        };
        window.addEventListener('resize',this.onPreviewResize,{passive:true});
        window.addEventListener('scroll',this.onPreviewScroll,{passive:true});
        this.previewScroller?.addEventListener('scroll',this.onPreviewScroll,{passive:true});
        if(previewImage&&!previewImage.complete)previewImage.addEventListener('load',()=>{
          this.previewBaseMetrics=null;
          requestAnimationFrame(()=>requestAnimationFrame(()=>{
            this.measureDesktopPreview();
            this.fitPreview();
          }));
        },{once:true});
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          this.measureDesktopPreview();
          this.fitPreview();
        }));
        this.accountInit();
        this.file.addEventListener('change', () => this.processPhoto());
        this.edge.addEventListener('input', () => this.paintSilhouette());
        this.size.addEventListener('input', () => this.updateSize());
        this.nameInput.addEventListener('input', () => this.updateName());
        this.querySelector('[data-clear]').addEventListener('click', () => this.clearPhoto());
        this.updateName();
        document.fonts.ready.then(()=>this.updateName());
      }

      updateName() {
        const value = this.nameInput.value.trim().slice(0, 18);
        this.namePreview.textContent = value;
        const length = [...value].length;
        this.namePreview.style.fontFamily=this.font.value;
        let size=Math.min(9.3, Math.max(3, Math.min(6.2, 27 / Math.max(5, length))) * Number(this.nameSize.value)/100);
        const stage=this.querySelector?.('[data-stage]');
        if(stage?.clientWidth){const ctx=document.createElement('canvas').getContext('2d');ctx.font='700 '+(stage.clientWidth*size/100)+'px "'+this.font.value+'"';const measured=ctx.measureText(value).width;if(measured>stage.clientWidth*.43)size*=stage.clientWidth*.43/measured;}
        this.namePreview.style.setProperty('--name-size',size+'cqw');
      }

      updateSize() {
        this.style.setProperty('--silhouette-scale', String(Number(this.size.value) / 100));
        this.shape.style.left=(25+Number(this.x.value))+'%';this.shape.style.top=(27+Number(this.y.value))+'%';
      }

      clearPhoto() {
        this.token++;
        this.file.value = '';
        this.mask = null;this.laserShape=null;
        this.shape.hidden = true;
        this.shape.removeAttribute('src');
        this.controls.hidden = true;
        this.status.textContent = '';
      }

      async digest(bytes){const hash=await crypto.subtle.digest('SHA-256',bytes);return Array.from(new Uint8Array(hash),b=>b.toString(16).padStart(2,'0')).join('');}
      async encodeFile(file){
        if(!file)return null;
        return new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve({name:file.name,data:reader.result});reader.onerror=reject;reader.readAsDataURL(file);});
      }
      async accountFile(file){
        if(!file)return null;
        const source=URL.createObjectURL(file);
        try{
          const image=new Image();image.src=source;await image.decode();
          const longest=Math.max(image.naturalWidth,image.naturalHeight),initial=Math.min(1,2048/longest);
          let width=Math.max(1,Math.round(image.naturalWidth*initial)),height=Math.max(1,Math.round(image.naturalHeight*initial));
          const base=(file.name||'foto').replace(/\.[^.]+$/,'').slice(0,110)||'foto';
          for(let pass=0;pass<5;pass++){
            const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
            const ctx=canvas.getContext('2d');ctx.drawImage(image,0,0,width,height);
            for(const quality of [.92,.82,.72,.62]){
              const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/webp',quality));
              if(blob&&blob.size<=1024*1024)return new File([blob],base+'.webp',{type:'image/webp'});
            }
            width=Math.max(1,Math.round(width*.8));height=Math.max(1,Math.round(height*.8));
          }
          throw Error('account-size');
        }finally{URL.revokeObjectURL(source);}
      }
      async decodeFile(value){
        if(value===null)return null;
        if(!value||typeof value.data!=='string'||value.data.length>24000000)throw Error('file');
        const match=/^data:(image\/(?:png|jpeg|webp));base64,([A-Za-z0-9+/=]+)$/.exec(value.data);if(!match)throw Error('file');
        const bytes=Uint8Array.from(atob(match[2]),c=>c.charCodeAt(0));if(bytes.length>17*1024*1024)throw Error('file');
        const file=new File([bytes],typeof value.name==='string'?value.name.slice(0,120):'ontwerp.png',{type:match[1]});
        const url=URL.createObjectURL(file);try{const img=new Image();img.src=url;await img.decode();if(img.naturalWidth*img.naturalHeight>40000000)throw Error('dimensions');}finally{URL.revokeObjectURL(url);}
        return file;
      }
      accountToken(){
        return sessionStorage.getItem('cc-account-session')||'';
      }
      setAccountToken(token){
        if(token)sessionStorage.setItem('cc-account-session',token);
        else sessionStorage.removeItem('cc-account-session');
      }
      accountTokenExpiresSoon(token=this.accountToken(),bufferSeconds=300){
        try{
          const part=token.split('.')[1];if(!part)return true;
          const normalized=part.replace(/-/g,'+').replace(/_/g,'/');
          const payload=JSON.parse(atob(normalized+'='.repeat((4-normalized.length%4)%4)));
          return !Number.isInteger(payload.exp)||payload.exp<=Math.floor(Date.now()/1000)+bufferSeconds;
        }catch{return true;}
      }
      storefrontAuthFresh(){
        const customerId=this.dataset.customerId||'',ts=Number(this.dataset.authTs),signature=this.dataset.authSignature||'',shopDomain=this.dataset.shopDomain||'';
        return /^\d+$/.test(customerId)&&Number.isInteger(ts)&&Math.abs(Math.floor(Date.now()/1000)-ts)<=720&&/^[0-9a-f]{40}$/i.test(signature)&&Boolean(shopDomain);
      }
      sessionExpiredError(){
        return Error(this.q('[data-account-status]').dataset.sessionExpired||this.q('[data-account-status]').dataset.login);
      }
      async refreshStorefrontAuth(){
        const status=this.q('[data-account-status]'),url=new URL(location.href);
        url.hash='';url.searchParams.set('cc_auth_refresh',Date.now().toString());
        let response;
        try{response=await fetch(url.href,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}});}
        catch{throw Error(status.dataset.failed);}
        if(!response.ok)throw Error(status.dataset.failed);
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=[...doc.querySelectorAll('cc-silhouette-editor')].find(editor=>editor.dataset.product===this.dataset.product);
        if(!fresh)throw Error(status.dataset.failed);
        const customerId=fresh.dataset.customerId||'',ts=Number(fresh.dataset.authTs),signature=fresh.dataset.authSignature||'',shopDomain=fresh.dataset.shopDomain||'';
        if(!/^\d+$/.test(customerId)||!Number.isInteger(ts)||!/^[0-9a-f]{40}$/i.test(signature)||!shopDomain)throw this.sessionExpiredError();
        if(this.dataset.customerId&&this.dataset.customerId!==customerId)throw this.sessionExpiredError();
        this.dataset.customerId=customerId;this.dataset.authTs=String(ts);this.dataset.authSignature=signature;this.dataset.shopDomain=shopDomain;
      }
      async requestEditorToken(){
        const status=this.q('[data-account-status]'),customerId=this.dataset.customerId||'',ts=Number(this.dataset.authTs),signature=this.dataset.authSignature||'',shopDomain=this.dataset.shopDomain||'';
        if(!/^\d+$/.test(customerId)||!Number.isInteger(ts)||!/^[0-9a-f]{40}$/i.test(signature)||!shopDomain)throw this.sessionExpiredError();
        const response=await fetch('https://ioefswfrixncfbmwsbmc.supabase.co/functions/v1/customer-designs?action=storefront-session',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({customerId,ts,signature,shopDomain})
        });
        let result={};try{result=await response.json();}catch{}
        if(!response.ok){const error=Error(result.error||status.dataset.login);error.status=response.status;throw error;}
        if(!result.token)throw Error(status.dataset.failed);
        this.setAccountToken(result.token);
        return result.token;
      }
      async ensureAccountSession(force=false){
        if(force)this.setAccountToken('');
        const existing=this.accountToken();
        if(existing&&!this.accountTokenExpiresSoon(existing))return existing;
        if(existing)this.setAccountToken('');
        let refreshed=false;
        if(force||!this.storefrontAuthFresh()){await this.refreshStorefrontAuth();refreshed=true;}
        try{return await this.requestEditorToken();}
        catch(error){
          if(!refreshed&&error.status===401){await this.refreshStorefrontAuth();return this.requestEditorToken();}
          throw error;
        }
      }
      async accountRequest(action,method='GET',data,retry=true){
        const status=this.q('[data-account-status]'),token=await this.ensureAccountSession();
        if(!token)throw this.sessionExpiredError();
        let requestBody=null,contentType='application/json';
        if(data){
          const json=JSON.stringify(data);
          if(action==='save'&&'CompressionStream' in window){
            requestBody=await new Response(new Blob([json],{type:'application/json'}).stream().pipeThrough(new CompressionStream('gzip'))).blob();
            if(requestBody.size>20*1024*1024)throw Error('account-size');
            contentType='application/gzip';
          }else requestBody=json;
        }
        const response=await fetch('https://ioefswfrixncfbmwsbmc.supabase.co/functions/v1/customer-designs?action='+action,{method,headers:{Authorization:'Bearer '+token,'X-CC-Editor':'1','Content-Type':contentType},...(data?{body:requestBody}:{})});
        let result={};try{result=await response.json();}catch{}
        if(!response.ok){
          if(response.status===401&&retry){this.setAccountToken('');await this.ensureAccountSession(true);return this.accountRequest(action,method,data,false);}
          if(response.status===401)this.setAccountToken('');
          const requestError=Error(result.error||status.dataset.failed);requestError.status=response.status;throw requestError;
        }
        return result;
      }
      async pendingDraft(mode,value){
        const db=await new Promise((resolve,reject)=>{const r=indexedDB.open('cc-pending-design',1);r.onupgradeneeded=()=>r.result.createObjectStore('drafts');r.onsuccess=()=>resolve(r.result);r.onerror=()=>reject(r.error);});
        try{return await new Promise((resolve,reject)=>{const tx=db.transaction('drafts',mode==='get'?'readonly':'readwrite'),s=tx.objectStore('drafts');const r=mode==='get'?s.get('pending'):mode==='put'?s.put(value,'pending'):s.delete('pending');let result;r.onsuccess=()=>{result=r.result;};tx.oncomplete=()=>resolve(result);tx.onerror=()=>reject(tx.error);tx.onabort=()=>reject(tx.error);});}finally{db.close();}
      }
      async accountInit(){
        const status=this.q('[data-account-status]');
        try{
          const params=new URLSearchParams(location.hash.slice(1)),incoming=params.get('cc_session');
          if(params.has('cc_design')||params.has('cc_resume')){status.textContent=status.dataset.loading;status.classList.add('is-loading');status.setAttribute('aria-busy','true');}
          if(incoming){history.replaceState(null,'',location.pathname+location.search);this.setAccountToken(incoming);}
          let token=this.accountToken();
          if(!token){
            try{token=await this.ensureAccountSession();}catch(error){token=null;}
          }
          if(!token){if(status.classList.contains('is-loading'))status.textContent=status.dataset.login;return;}
          await this.accountRequest('list');
          const id=params.get('cc_design');
          if(id){const data=await this.accountRequest('get&id='+encodeURIComponent(id));const ok=await this.loadDesign(new File([JSON.stringify(data.design)],'account.ccdesign',{type:'application/json'}));if(ok){this.accountDesign={id:data.id,revision:data.revision};this.q('[data-account-title]').value=data.title;status.textContent=status.dataset.loaded;}}
          else if(params.get('cc_resume')){
            const draft=await this.pendingDraft('get');
            if(draft&&Date.now()-draft.created<24*60*60*1000){
              if(draft.handle!==this.dataset.productHandle&&/^[a-z0-9][a-z0-9-]*$/.test(draft.handle)){const next=new URL('/products/'+draft.handle,location.origin);next.search=location.search;next.hash=new URLSearchParams({cc_session:token,cc_resume:'1'}).toString();location.assign(next);return;}
              if(await this.loadDesign(new File([JSON.stringify(draft.design)],'pending.ccdesign',{type:'application/json'}))){
                this.q('[data-account-title]').value=draft.title;
                this.accountDesign=draft.accountDesign&&typeof draft.accountDesign==='object'?draft.accountDesign:null;
                const saved=await this.saveAccount(Boolean(draft.copy));
                if(saved){await this.pendingDraft('delete');status.textContent=status.dataset.saved;}
              }
            }else{await this.pendingDraft('delete');status.textContent=status.dataset.ready;}
          }
        }catch(error){status.textContent=error.message||status.dataset.failed;}finally{status.classList.remove('is-loading');status.removeAttribute('aria-busy');}
      }
      async saveAccount(copy=false){
        const status=this.q('[data-account-status]');if(this.processing||this.designWorking||this.photos.some(p=>p.loading))return false;
        const title=this.q('[data-account-title]').value.trim();if(!title){this.q('[data-account-title]').focus();status.textContent=this.q('[data-account-title]').closest('label').textContent;return false;}
        this.designWorking=true;this.form.inert=true;status.textContent=status.dataset.saving;status.classList.add('is-loading');status.setAttribute('aria-busy','true');
        try{
          const token=await this.ensureAccountSession();
          if(!token){status.textContent=status.dataset.sessionExpired||status.dataset.login;return false;}
          const design=await this.exportAccountDesign();
          const payload={design,preview:await this.createDesignPreview(),title,handle:this.dataset.productHandle,...(!copy&&this.accountDesign?this.accountDesign:{})};
          status.textContent=status.dataset.saving;
          let saved;
          try{
            saved=await this.accountRequest('save','POST',payload);
          }catch(error){
            if(!copy&&this.accountDesign&&error.status===404){
              this.accountDesign=null;
              const freshPayload={design,preview:payload.preview,title,handle:this.dataset.productHandle};
              saved=await this.accountRequest('save','POST',freshPayload);
            }else throw error;
          }
          this.accountDesign={id:saved.id,revision:saved.revision};status.textContent=status.dataset.saved;return true;
        }catch(error){status.textContent=error.message==='account-size'?status.dataset.tooLarge:(error.message||status.dataset.failed);return false;}
        finally{status.classList.remove('is-loading');status.removeAttribute('aria-busy');this.designWorking=false;this.form.inert=false;}
      }
      q(selector){return this.querySelector(selector);}
      disconnectedCallback(){window.removeEventListener('beforeunload',this.beforeUnload);window.removeEventListener('resize',this.onPreviewResize);window.removeEventListener('scroll',this.onPreviewScroll);this.previewScroller?.removeEventListener('scroll',this.onPreviewScroll);}
      render(){
        this.updateName();this.updateSize();
        const emptyText={text:'',font:'Arial',size:10,x:50,y:50,angle:0};
        const emptyImage={fileHash:null,grayscale:true,backgroundRemoved:false,size:60,x:50,y:50,angle:0};
        this.layout={v:3,texts:[{...emptyText,text:this.nameInput.value.trim(),font:this.font.value},emptyText,emptyText],images:[{...emptyImage,fileHash:this.mask?'silhouette':null,backgroundRemoved:Boolean(this.mask)},emptyImage],silhouette:{v:1,edge:Number(this.edge.value),size:Number(this.size.value),x:Number(this.x.value),y:Number(this.y.value),nameSize:Number(this.nameSize.value)},scaleCalibrated:false};
        this.q('[data-layout]').value=JSON.stringify(this.layout);
      }
      maskFile(){
        if(!this.mask)return null;
        const c=document.createElement('canvas');c.width=this.mask.width;c.height=this.mask.height;
        const ctx=c.getContext('2d'),pixels=ctx.createImageData(c.width,c.height);
        for(let i=0;i<pixels.data.length;i+=4){pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=255;pixels.data[i+3]=this.mask.data[i+3];}ctx.putImageData(pixels,0,0);
        return CCSilhouettePackage.blob(c).then(b=>new File([b],'silhouet-masker.png',{type:'image/png'}));
      }
      async exportAccountDesign(){
        this.render();return {format:'carved-crafts-design',version:1,product:this.dataset.product,variant:this.form.elements.id.value,layout:this.layout,files:[{original:await this.encodeFile(this.file.files[0]),processed:await this.encodeFile(await this.maskFile())},{original:null,processed:null}]};
      }
      async saveDesign(){
        const status=this.q('[data-design-status]');if(this.processing||this.designWorking){status.textContent=status.dataset.busy;return;}
        this.designWorking=true;status.textContent=status.dataset.saving;status.classList.add('is-loading');status.setAttribute('aria-busy','true');
        try{const design=await this.exportAccountDesign();this.download(new Blob([JSON.stringify(design)],{type:'text/plain'}),'Carved-Crafts-silhouet-ontwerp.txt');status.textContent=status.dataset.saved;}catch{status.textContent=status.dataset.failed;}finally{status.classList.remove('is-loading');status.removeAttribute('aria-busy');this.designWorking=false;}
      }
      download(blob,name){const url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download=name;link.click();setTimeout(()=>URL.revokeObjectURL(url),2000);}
      async loadDesign(providedFile){
        const status=this.q('[data-design-status]'),input=this.q('[data-design-file]'),file=providedFile||input.files[0];input.value='';if(!file)return false;
        if(this.designWorking||this.processing){status.textContent=status.dataset.busy;return false;}this.designWorking=true;status.textContent=status.dataset.loading;status.classList.add('is-loading');status.setAttribute('aria-busy','true');
        try{
          if(file.size>30*1024*1024)throw Error('size');const d=JSON.parse(await file.text()),c=d.layout?.silhouette,t=d.layout?.texts?.[0];
          if(d.format!=='carved-crafts-design'||d.version!==1||d.product!==this.dataset.product||c?.v!==1||!t||!Array.from(this.font.options).some(o=>o.value===t.font)||typeof t.text!=='string'||t.text.length>18||d.files?.length!==2)throw Error('design');
          const valid=(n,min,max)=>Number.isFinite(n)&&n>=min&&n<=max;
          if(!valid(c.edge,35,210)||!valid(c.size,65,200)||!valid(c.x,-25,25)||!valid(c.y,-25,25)||!valid(c.nameSize,50,200))throw Error('range');
          const original=await this.decodeFile(d.files[0].original),processed=await this.decodeFile(d.files[0].processed);
          if(Boolean(original)!==Boolean(processed)||original?.size>8*1024*1024)throw Error('files');
          let mask=null;if(processed){const url=URL.createObjectURL(processed);try{const image=new Image();image.src=url;await image.decode();if(image.naturalWidth>1400||image.naturalHeight>1400)throw Error('mask');const canvas=document.createElement('canvas');canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;const ctx=canvas.getContext('2d');ctx.drawImage(image,0,0);mask=ctx.getImageData(0,0,canvas.width,canvas.height);}finally{URL.revokeObjectURL(url);}}
          this.clearPhoto();if(original){const transfer=new DataTransfer();transfer.items.add(original);this.file.files=transfer.files;}
          this.nameInput.value=t.text;this.font.value=t.font;for(const key of ['edge','size','x','y'])this[key].value=c[key];this.nameSize.value=c.nameSize;this.mask=mask;
          if(mask){if(!this.woodImage)this.woodImage=await this.loadWoodImage();this.paintSilhouette();this.controls.hidden=false;}
          this.render();this.accountDesign=null;status.textContent=status.dataset.loaded;return true;
        }catch{status.textContent=status.dataset.failed;return false;}finally{status.classList.remove('is-loading');status.removeAttribute('aria-busy');this.designWorking=false;}
      }
      async drawComposite(preview=false,width=1600){
        await document.fonts.ready;
        const c=document.createElement('canvas');c.width=c.height=width;const ctx=c.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,width,width);
        if(preview){const base=new Image();base.crossOrigin='anonymous';const source=this.q('.cc-product-image');base.src=source.currentSrc||source.src;await base.decode();ctx.drawImage(base,0,0,width,width);}
        if(this.mask&&!this.shape.hidden){
          await this.shape.decode();const naturalW=this.shape.naturalWidth,naturalH=this.shape.naturalHeight;
          const contain=Math.min(width*.50/naturalW,width*.43/naturalH),scale=Number(this.size.value)/100;
          const boxLeft=width*(.25+Number(this.x.value)/100),boxTop=width*(.27+Number(this.y.value)/100);
          const drawW=naturalW*contain,drawH=naturalH*contain;
          const left=boxLeft+(width*.50-drawW)/2,top=boxTop+width*.43-drawH;
          ctx.save();ctx.beginPath();ctx.arc(width*.5,width*.55,width*.30,0,Math.PI*2);ctx.clip();
          ctx.beginPath();ctx.rect(0,0,width,width*.688);ctx.clip();
          ctx.translate(boxLeft+width*.25,boxTop+width*.43);ctx.scale(scale,scale);ctx.translate(-(boxLeft+width*.25),-(boxTop+width*.43));
          if(preview){ctx.shadowColor='rgba(31,18,10,.45)';ctx.shadowBlur=width*.003;ctx.shadowOffsetY=width*.003;ctx.drawImage(this.shape,left,top,drawW,drawH);}
          else if(this.laserShape)ctx.drawImage(this.laserShape,left,top,this.laserShape.width*contain,this.laserShape.height*contain);
          ctx.restore();
        }
        const name=this.nameInput.value.trim().slice(0,18),length=[...name].length;
        let size=width*Math.min(9.3,Math.max(3,Math.min(6.2,27/Math.max(5,length)))*Number(this.nameSize.value)/100)/100;
        ctx.font='700 '+size+'px "'+this.font.value+'"';const max=width*.43;
        if(ctx.measureText(name).width>max){size*=max/ctx.measureText(name).width;ctx.font='700 '+size+'px "'+this.font.value+'"';}
        ctx.fillStyle=preview?'#6d3e20':'#000';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(name,width*.485,width*.78,max);return c;
      }
      async createDesignPreview(){return (await this.drawComposite(true,360)).toDataURL('image/png');}
      async buildPackage(){
        this.render();const art=await this.drawComposite(false),proof=await this.drawComposite(true),png=await CCSilhouettePackage.blob(art),preview=await CCSilhouettePackage.blob(proof);
        const meta={product:this.dataset.product,layout:this.layout,widthMm:null,heightMm:null,scaleStatus:'unknown-do-not-use-as-physical-size'};
        const svg=new Blob(['<svg xmlns="http://www.w3.org/2000/svg" width="'+art.width+'" height="'+art.height+'" viewBox="0 0 '+art.width+' '+art.height+'"><title>Fysieke maat instellen voor productie</title><image width="'+art.width+'" height="'+art.height+'" href="'+art.toDataURL('image/png')+'"/></svg>'],{type:'image/svg+xml'});
        const entries=[['Gravure.svg',svg],['Gravure.png',png],['Controlevoorbeeld.png',preview],['Ontwerpindeling.json',new Blob([JSON.stringify(meta,null,2)],{type:'application/json'})],['LEESMIJ.txt',new Blob(['De fysieke diameter is nog niet vastgesteld. Stel voor productie de juiste maat in LightBurn of Inkscape in. Gravure.png bevat uitsluitend zwart silhouet en tekst op wit. Controlevoorbeeld.png bevat de houten productweergave. Het bestelnummer wordt pas bij bestelling bekend.'],{type:'text/plain'})]];
        const original=this.file.files[0];if(original)entries.push(['Originele-fotos/'+original.name.replace(/[^a-zA-Z0-9_.-]/g,'_'),original]);
        const zip=await CCSilhouettePackage.zip(entries);if(zip.size>19*1024*1024)throw Error('package-size');return {zip,preview};
      }
      updatePrice(){
        const panel=this.q('[data-purchase]'),qty=Math.max(1,Math.floor(Number(this.form.elements.quantity.value)||1));
        const tier=qty>=10?10:qty>=5?5:qty>=2?2:1,discount=tier===10?12:tier===5?8:tier===2?5:0;
        const base=Number(panel.dataset.price),unit=base-Math.floor(base*discount/100),boardsTotal=unit*qty,currency=panel.dataset.currency||'EUR';
        const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'nl',{style:'currency',currency}).format(cents/100);
        const unitMoney=cents=>new Intl.NumberFormat(document.documentElement.lang||'nl',{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
        let extras=0;
        this.querySelectorAll('[data-addon]').forEach(addon=>{
          const amount=addon.checked?Number(addon.dataset.price):0;extras+=amount;
          const row=this.q('[data-addon-row="'+addon.dataset.addonType+'"]');
          if(row){row.hidden=!addon.checked;row.querySelector('[data-addon-total]').textContent=money(amount);}
        });
        this.q('[data-unit-price]').textContent=unitMoney(unit);
        this.q('[data-boards-total]').textContent=money(boardsTotal);
        this.q('[data-price-total]').textContent=money(boardsTotal+extras);
        this.querySelectorAll('[data-tier]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.tier)===tier)));
      }
      async submit(event){
        event.preventDefault();const status=this.q('[data-error]'),button=this.q('[type="submit"]');if(button.disabled||this.submitting||this.processing||this.designWorking)return;
        if(!this.mask&&!this.nameInput.value.trim()){status.textContent=this.words.photo_required;return;}
        this.submitting=true;button.disabled=true;status.textContent=this.words.preparing_package;
        const renamed=[],added=[];let packageReady=false;
        try{const pack=await this.buildPackage();for(const [selector,blob,name]of [['[data-production-zip]',pack.zip,'Bestelpakket-silhouet.zip'],['[data-production-proof]',pack.preview,'Controlevoorbeeld-silhouet.png']]){const transfer=new DataTransfer();transfer.items.add(new File([blob],name,{type:blob.type}));this.q(selector).files=transfer.files;}
          packageReady=true;
          this.q('[data-design-key]').value=await this.digest(new TextEncoder().encode(JSON.stringify(this.layout)));
          const addons=[...this.querySelectorAll('[data-addon]:checked')];
          if(addons.length){
            const parentVariantId=this.form.elements.id.value,designKey=this.q('[data-design-key]').value;
            for(const field of this.form.elements){
              renamed.push([field,field.name]);
              if(field.name==='id'||field.name==='quantity')field.name='items[0]['+field.name+']';
              else if(field.name.startsWith('properties['))field.name='items[0][properties]'+field.name.slice(10);
            }
            addons.forEach((addon,index)=>{
              const itemIndex=index+1,fields={
                ['items['+itemIndex+'][id]']:addon.dataset.variant,
                ['items['+itemIndex+'][quantity]']:'1',
                ['items['+itemIndex+'][parent_id]']:parentVariantId,
                ['items['+itemIndex+'][properties][_Ontwerpcode]']:designKey
              };
              for(const [name,value] of Object.entries(fields)){
                const field=document.createElement('input');field.type='hidden';field.name=name;field.value=value;this.form.append(field);added.push(field);
              }
            });
          }
          this.navigatingToCart=true;HTMLFormElement.prototype.submit.call(this.form);
        }catch{this.navigatingToCart=false;for(const [field,name] of renamed)field.name=name;for(const field of added)field.remove();this.submitting=false;button.disabled=false;status.textContent=packageReady?this.words.cart_failed:this.words.package_failed;}
      }

      async getSegmenter() {
        if (!CCSilhouetteEditor.segmenterPromise) {
          CCSilhouetteEditor.segmenterPromise = (async () => {
            const lib = await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.8.1');
            lib.env.allowLocalModels = false;
            lib.env.backends.onnx.wasm.numThreads = 1;
            lib.env.backends.onnx.wasm.proxy = true;
            return lib.pipeline('background-removal', 'onnx-community/ormbg-ONNX', { dtype:'q8', device:'wasm' });
          })().catch(error => { CCSilhouetteEditor.segmenterPromise = null; throw error; });
        }
        return CCSilhouetteEditor.segmenterPromise;
      }

      async loadWoodImage() {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = this.dataset.woodUrl;
        await image.decode();
        const probe = document.createElement('canvas');
        probe.width = probe.height = 1;
        const ctx = probe.getContext('2d', { willReadFrequently:true });
        ctx.drawImage(image,0,0,1,1);
        ctx.getImageData(0,0,1,1);
        return image;
      }

      async processPhoto() {
        const file = this.file.files[0];
        const token = ++this.token;
        this.mask = null;this.laserShape=null;
        this.shape.hidden = true;
        this.controls.hidden = true;
        if (!file) { this.status.textContent = ''; return; }
        if (!['image/png','image/jpeg','image/webp'].includes(file.type) || file.size > 8 * 1024 * 1024) {
          this.status.textContent = this.words.photo_invalid;
          this.file.value = '';
          return;
        }
        this.processing=true;this.file.disabled = true;
        this.status.classList.add('is-loading');this.status.setAttribute('aria-busy','true');
        this.status.textContent = this.words.processing;
        const source = URL.createObjectURL(file);
        let cutout;
        try {
          const probeImage=new Image();probeImage.src=source;await probeImage.decode();
          if(probeImage.naturalWidth*probeImage.naturalHeight>40000000)throw Error('dimensions');
          const probe=document.createElement('canvas');probe.width=probe.height=64;
          const probeCtx=probe.getContext('2d',{willReadFrequently:true});probeCtx.drawImage(probeImage,0,0,64,64);
          const probePixels=probeCtx.getImageData(0,0,64,64).data;
          const transparent=probePixels.some((v,i)=>i%4===3&&v<20);
          if(transparent)cutout=source;
          else{
            const segmenter = await this.getSegmenter();
            if (token !== this.token) return;
            const output = await segmenter(source);
            if (token !== this.token) return;
            cutout = URL.createObjectURL(await output[0].toBlob());
          }
          const image = new Image();
          image.src = cutout;
          await image.decode();
          if (token !== this.token) return;
          const scale = Math.min(1, 1400 / Math.max(image.naturalWidth, image.naturalHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          const ctx = canvas.getContext('2d', { willReadFrequently:true });
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          this.mask = ctx.getImageData(0, 0, canvas.width, canvas.height);
          if (!this.woodImage) this.woodImage = await this.loadWoodImage().catch(() => null);
          if (token !== this.token) return;
          this.paintSilhouette();
          this.controls.hidden = false;
          this.status.textContent = this.words.ready;
        } catch (error) {
          if (token === this.token) this.status.textContent = this.words.failed;
        } finally {
          URL.revokeObjectURL(source);
          if (cutout) URL.revokeObjectURL(cutout);
          if (token === this.token) {
            this.processing=false;this.file.disabled = false;
            this.status.classList.remove('is-loading');this.status.removeAttribute('aria-busy');
          }
        }
      }

      paintSilhouette() {
        if (!this.mask) return;
        const { width, height, data } = this.mask;
        const threshold = Number(this.edge.value);
        let left = width, top = height, right = -1, bottom = -1;
        for (let y=0; y<height; y++) {
          for (let x=0; x<width; x++) {
            if (data[(y*width+x)*4+3] < threshold) continue;
            left = Math.min(left,x); right = Math.max(right,x);
            top = Math.min(top,y); bottom = Math.max(bottom,y);
          }
        }
        if (right < left || bottom < top) {
          this.status.textContent = this.words.no_subject;
          this.shape.hidden = true;
          return;
        }
        const pad = Math.max(4, Math.round(Math.max(right-left,bottom-top) * .04));
        const x0 = Math.max(0,left-pad), y0 = Math.max(0,top-pad);
        const face = document.createElement('canvas');
        face.width = Math.min(width,right+pad+1)-x0;
        face.height = Math.min(height,bottom+pad+1)-y0;
        const faceCtx = face.getContext('2d');
        const pixels = faceCtx.createImageData(face.width,face.height);
        for (let y=0; y<face.height; y++) {
          for (let x=0; x<face.width; x++) {
            const alpha = data[((y+y0)*width+x+x0)*4+3];
            const i = (y*face.width+x)*4;
            pixels.data[i] = 255;
            pixels.data[i+1] = 255;
            pixels.data[i+2] = 255;
            pixels.data[i+3] = alpha >= threshold ? 255 : 0;
          }
        }
        faceCtx.putImageData(pixels,0,0);
        this.laserShape=document.createElement('canvas');this.laserShape.width=face.width;this.laserShape.height=face.height;
        const laser=this.laserShape.getContext('2d');laser.drawImage(face,0,0);laser.globalCompositeOperation='source-in';laser.fillStyle='#000';laser.fillRect(0,0,face.width,face.height);
        faceCtx.globalCompositeOperation = 'source-in';
        if (this.woodImage) {
          faceCtx.drawImage(this.woodImage,0,0,face.width,face.height);
        } else {
          faceCtx.fillStyle = '#795135';
          faceCtx.fillRect(0,0,face.width,face.height);
        }
        faceCtx.globalCompositeOperation = 'source-atop';
        if (!this.woodImage) {
          faceCtx.strokeStyle = 'rgba(47,26,15,.16)';
          faceCtx.lineWidth = Math.max(1,face.width/650);
          for (let y=7; y<face.height; y+=13) {
            faceCtx.beginPath();
            faceCtx.moveTo(0,y);
            faceCtx.bezierCurveTo(face.width*.3,y-3,face.width*.6,y+3,face.width,y);
            faceCtx.stroke();
          }
        }
        const shade = faceCtx.createLinearGradient(0,0,face.width,face.height);
        shade.addColorStop(0,'rgba(244,196,141,.17)');
        shade.addColorStop(.55,'rgba(57,28,12,.04)');
        shade.addColorStop(1,'rgba(33,16,8,.24)');
        faceCtx.fillStyle = shade;
        faceCtx.fillRect(0,0,face.width,face.height);
        faceCtx.globalCompositeOperation = 'source-over';

        const side = document.createElement('canvas');
        side.width = face.width;
        side.height = face.height;
        const sideCtx = side.getContext('2d');
        sideCtx.drawImage(face,0,0);
        sideCtx.globalCompositeOperation = 'source-in';
        sideCtx.fillStyle = '#321c11';
        sideCtx.fillRect(0,0,side.width,side.height);

        const depth = Math.max(3,Math.round(Math.max(face.width,face.height)*.018));
        const out = document.createElement('canvas');
        out.width = face.width+depth+4;
        out.height = face.height+depth+4;
        const ctx = out.getContext('2d');
        ctx.shadowColor = 'rgba(35,19,10,.40)';
        ctx.shadowBlur = depth*.8;
        ctx.shadowOffsetX = depth*.45;
        ctx.shadowOffsetY = depth*.8;
        ctx.drawImage(side,depth,depth);
        ctx.shadowColor = 'transparent';
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
        for (let step=depth; step>=1; step--) ctx.drawImage(side,step,step);
        ctx.drawImage(face,0,0);
        this.shape.src = out.toDataURL('image/png');
        this.shape.hidden = false;
        this.updateSize();
      }
    }
    customElements.define('cc-silhouette-editor', CCSilhouetteEditor);
  }
  } catch(e) { console.error(e); }
})();

})();
